'use client';

import Link from 'next/link';
import { trackEvent } from '../../lib/analytics/posthog';
import { EVENTS } from '../../lib/analytics/events';

export default function DirectoryLink({ href, children, linkType, linkName, className, ...props }) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() => trackEvent(EVENTS.DIRECTORY_LINK_CLICKED, { link_type: linkType, link_name: linkName })}
      {...props}
    >
      {children}
    </Link>
  );
}
